module.exports = __webpack_public_path__ + "df99be51.png";